define('common/geo-location', ['jquery', 'jquery.cookie'], ($) => {
    function getCurrentPosition(cb = () => {}) {
        const cookieGeo = $.cookie('geo');
        if (cookieGeo) {
            cb(JSON.parse(cookieGeo));
            return;
        }
        // 浏览器获取
        if ('geolocation' in navigator) {
            const geolocation = navigator.geolocation;
            const geoSuccess = function (position) {
                const geo = {
                    lat: (position.coords.latitude || 0).toFixed(7),
                    lng: (position.coords.longitude || 0).toFixed(7)
                };
                $.cookie('geo', JSON.stringify(geo), {
                    expires: 1,
                    path: '/'
                });
                cb(geo);
            };
            const geoError = function () {
                cb();
                // let errTxt = ''
                // switch (error.code) {
                //     case error.PERMISSION_DENIED:
                //         errTxt = '请允许人人车获取您的地理位置!'
                //         break
                //     case error.POSITION_UNAVAILABLE:
                //         errTxt = '获取地理位置内部错误!'
                //         break
                //     case error.TIMEOUT:
                //         errTxt = '获取地理位置超时!'
                //         break
                //     case error.UNKNOWN_ERROR:
                //         errTxt = '获取地理位置是，发生未知错误!'
                //         break
                // }
                // self.$toast(errTxt)
            };
            const options = {
                timeout: 10000,
                maximumAge: 3600000
            };
            geolocation.getCurrentPosition(geoSuccess, geoError, options);
        }
    }


    return {
        getCurrentPosition,
    };
});

